import { useState } from 'react';

import { IToggleReactionItemProps } from './interfaces';
import BaseReactionItem from './BaseReactionItem';

const ToggleReactionItem = ({
  onClick,
  activeImage,
  inactiveImage,
  title,
}: IToggleReactionItemProps) => {
  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    setIsActive((prevState) => !prevState);
    onClick();
  };

  return (
    <BaseReactionItem
      onClick={handleClick}
      previewImage={isActive ? activeImage : inactiveImage}
      title={title}
    />
  );
};

export default ToggleReactionItem;
